import { Cloud } from ".";

export function validatePromoCode({ promoCode }: { promoCode: string }): Promise<{ error?: "expired" } | null> {
  return Cloud.run("validatePromoCode", { promoCode });
}

export function getGiftCard({
  promoCodeType = "subscription_year",
  productId,
  couponCode,
  countryCode = "US"
}: {
  promoCodeType?: string;
  productId: string;
  couponCode: string;
  countryCode: string;
}) {
  return Cloud.run("getPaddleGiftCardProduct", {
    promoCodeType,
    countryCode,
    productId,
    couponCode
  });
}

export function redeemPromoCode({ promoCode }: { promoCode: string }) {
  return Cloud.run("redeemPromoCode", { promoCode });
}
